import { render, staticRenderFns } from "./shaicha-list.vue?vue&type=template&id=a59e8716&scoped=true"
import script from "./shaicha-list.vue?vue&type=script&lang=ts"
export * from "./shaicha-list.vue?vue&type=script&lang=ts"
import style0 from "./shaicha-list.vue?vue&type=style&index=0&id=a59e8716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e8716",
  null
  
)

export default component.exports